/* eslint-disable camelcase */
import assign from "lodash/fp/assign";
import dateDialogTemplate from "./dailog/dateDialog.html";
import dateDialogController from "./dailog/dateDialog.controller";
import constants from "../../core/constants";
import moment from "moment";

class Controller {
  constructor(Events, $mdDialog) {
    "ngInject";

    this.Events = Events;
    this.$mdDialog = $mdDialog;
  }

  $onInit() {
    this.dateObject = assign({}, this.selected);
    const formatSelected = () => {
      if (this.selected.date) {
        this.dateValue = moment(this.selected.date).format(
          constants.dateFormat
        );
        this.selected.date = this.dateValue;
      }
      if (this.selected.travel_date) {
        this.dateValue = moment(this.selected.travel_date).format(
          constants.dateFormat
        );
        this.selected.travel_date = this.dateValue;
      }
      if (this.selected.createdAt) {
        this.dateValue = moment(this.selected.createdAt).format(
          constants.dateFormat
        );
        this.selected.createdAt = this.dateValue;
      }
      if (this.selected.created_at) {
        this.dateValue = moment(this.selected.created_at).format(
          constants.dateFormat
        );
        this.selected.created_at = this.dateValue;
      }
      if (this.selected.start_date && this.selected.end_date) {
        this.dateValue =
          moment(this.selected.start_date).format(constants.dateFormat) +
          ", " +
          moment(this.selected.end_date).format(constants.dateFormat);
        this.selected = this.dateValue;
      }

      if (this.selected.start_date && !this.selected.end_date) {
        this.dateValue = `${moment(this.selected.start_date).format(
          constants.dateFormat
        )}/...`;
        this.selected = this.dateValue;
      }

      if (this.selected.end_date && !this.selected.start_date) {
        this.dateValue = `.../${moment(this.selected.end_date).format(
          constants.dateFormat
        )}`;
        this.selected = this.dateValue;
      }
    };
    formatSelected();

    this.open = () => {
      const selectDate = this.$mdDialog.show({
        controller: dateDialogController,
        controllerAs: "$ctrl",
        template: dateDialogTemplate,
        locals: {
          selected: this.dateObject,
          hasRange: this.hasRange,
          hasDate: this.hasDate,
          name: this.name,
        },
      });

      selectDate.then(
        (objs) => {
          const options = {};
          for (const key in objs) {
            if (
              (key === "date" && objs[key]) ||
              (key === "travel_date" && objs[key]) ||
              (key === "createdAt" && objs[key]) ||
              (key === "created_at" && objs[key])
            ) {
              options[key] = moment(objs[key])
                .startOf("day")
                .toDate()
                .toISOString();
              options.start_date = null;
              options.end_date = null;
            } else if (
              (key === "start_date" && objs[key]) ||
              (key === "end_date" && objs[key])
            ) {
              options[key] = moment(objs[key])
                .startOf("day")
                .toDate()
                .toISOString();
              options.createdAt = null;
              options.created_at = null;
              options.travel_date = null;
              options.date = null;
            }
          }
          options.page = 1; // Avoid filtration result with fewer pages than the actual
          this.selected = objs;
          this.Events.emit(this.eventName, options);
          formatSelected();
        },
        () => {}
      );
    };
  }

  clear() {
    this.selected = null;
    this.dateObject = null;
    this.dateValue = null;
    this.Events.emit(this.eventName, {
      travel_date: null,
      created_at: null,
      createdAt: null,
      date: null,
      start_date: null,
      end_date: null,
    });
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/dateFilter/dateFilter.controller.js